const colors = {
  ttoo: "#5D4954",
  online: "#ACC3D8",
  direct: "#60A3D9",
  groups: "#AF5D63",
  adr_mean: "#3D5467",
  target: "#F4D35E",

  current: "#04395E",
  magic_price: "#98B9F2",
  compset: "#CC8B86"
};

export { colors };
export default colors;
